// Public landing route — '/'.
//
// One heading, one sentence, two actions. The primary action depends on
// auth state: signed-in users get the console, everyone else gets Sign in.
// Auth state is read reactively via the zustand selector so the CTA
// updates in place after login without a full navigation.
//
// data-testid hooks: `landing-cta` marks the primary action so a smoke
// test can assert the rendered CTA without coupling to copy.
import { createFileRoute, Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import { useIsAuthenticated } from '@/stores/auth-store'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  const isAuthenticated = useIsAuthenticated()

  return (
    <main
      data-testid="landing-page"
      className="landing-art flex min-h-[calc(100dvh-3.5rem)] w-full flex-col justify-center px-6 py-16 sm:px-[max(2rem,calc((100vw-1200px)/2))]"
    >
      <h1 className="max-w-2xl font-display text-6xl leading-none tracking-wide text-foreground sm:text-8xl">
        LiveVane streaming server
      </h1>
      <p className="mt-3 max-w-prose text-base text-muted-foreground">
        Watch the live streams, or sign in to run the console.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        {isAuthenticated ? (
          <Button asChild size="lg" data-testid="landing-cta">
            <Link to="/admin">Open the console</Link>
          </Button>
        ) : (
          <Button asChild size="lg" data-testid="landing-cta">
            <Link to="/login">Sign in</Link>
          </Button>
        )}
        <Button asChild size="lg" variant="outline">
          <Link to="/streams">Watch live streams</Link>
        </Button>
      </div>
    </main>
  )
}
